<template>
  <div class="desk-frame contact-page cellosign-page">
    <div
      class="head_row_calander bg--white flex flex--content--center no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">טפסי הסכמה</h1>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <div class="contact h-main bg--white m-no-bg page-edit-padd">
        <div v-if="step === 0" class="before-send">
          <div class="text center let-1 mb--27">
            רופא/ה יקר/ה, <br />
            יש לבחור את טופס ההסכמה המבוקש מהרשימה המוצגת ולהשלים את מספר הטלפון
            של המטופל/ת אם אינו מוצג. מיד לאחר הלחיצה על הכפתור, יוצג הטופס
            בפניך לשם השלמת הפרטים ע"י המטופל/ת. לאחר השלמתם, עליך לחתום על
            הטופס במקום המיועד וללחוץ על הכפתור "שלח טופס" לשם השלמת הפעולה.
          </div>

          <ValidationObserver ref="cellosignForm">
            <form @submit.prevent="submitForm" autocomplete="off">
              <div class="contact-col2 ">
                <div class="form_input">
                  <label>שם הטופס</label>
                  <validation-provider
                    name="template"
                    mode="lazy"
                    :rules="{
                      required: true
                    }"
                    v-slot="{ errors }"
                  >
                    <div
                      class="add_new_row_col2 w-100 input-opacity relative right-multiselect"
                    >
                      <multiselect
                        placeholder="בחר טפס הסכמה"
                        v-model="selectedTemplateOption"
                        :options="templates"
                        label="name"
                        track-by="key"
                        :searchable="true"
                        :allow-empty="false"
                      ></multiselect>
                    </div>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>

                <div class="form_input">
                  <label>טלפון נייד של המטופל/ת</label>
                  <validation-provider
                    name="phone2"
                    mode="lazy"
                    :rules="{
                      required: true,
                      regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                    }"
                    v-slot="{ errors }"
                  >
                    <input
                      name="phone2"
                      v-model="phone"
                      type="tel"
                      autocomplete="off"
                      placeholder="הקלד/י"
                    />
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="form_submit center">
                <a
                  class="bt_blue bt-approveDelete m-100"
                  @click="submitForm"
                  href="javascript:void(0)"
                >
                  שליחה
                  <vue-loaders-ball-clip-rotate
                    v-show="isLoading"
                    color="white"
                    scale="1.2"
                    style="position: relative;top: 9px;"
                  ></vue-loaders-ball-clip-rotate>
                </a>
              </div>
            </form>
          </ValidationObserver>
        </div>
        <div v-if="step === 1" class="iframe-container">
          <button class="back-button" @click="onStepBack" type="button">
            <span class="arrow">‹</span>
            <span>חזור לטפסי הסכמה</span>
          </button>
          <iframe
            :src="iframeUrl"
            width="100%"
            height="700vh"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import { mapGetters, mapState } from "vuex";
import { sendCelloSignGeneric } from "../api/api-quatro.js";
import { ivfTemplates } from "../utilities/ivf";

const IVF_BPMN_BASE = "https://app.cellosign.com/api/v3/ivf_forms/bpmn";
const IVF_PROJECT = "ivf_forms";
const IVF_TOKEN = "340564a53b3d5c5044ed65433cc5b73c16eacd59";

const buildIvfBpmnUrl = template => `${IVF_BPMN_BASE}/${template}/start/`;

export default {
  name: "Cellosign",
  components: { DashboardHeader, Menu, MenuDesktop, Multiselect },
  data() {
    return {
      step: 0,
      iframeUrl: "",
      templates: ivfTemplates,
      selectedTemplate: "",
      phone: "",
      patient: null,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"]),
    ...mapState(["activeDoctor"]),
    selectedTemplateOption: {
      get() {
        return (
          this.templates.find(t => t.key === this.selectedTemplate) || null
        );
      },
      set(option) {
        this.selectedTemplate = option ? option.key : "";
      }
    }
  },
  methods: {
    async submitForm() {
      const isValid = await this.$refs.cellosignForm.validate();
      if (!isValid || !this.activeDoctor || this.isLoading) return;

      this.isLoading = true;

      const data = {
        id: this.selectedTemplate,
        phone: this.phone,
        heb_name: this.activeDoctor.name,
        license: this.activeDoctor.license,
        mdbid: this.activeDoctor.id || "3136",
        wait_for_first_session: true
      };

      if (this.patient) {
        Object.assign(data, this.patient);
      }

      const req = {
        url: buildIvfBpmnUrl(this.selectedTemplate),
        template: this.selectedTemplate,
        project: IVF_PROJECT,
        token: IVF_TOKEN,
        data
      };

      try {
        const response = await sendCelloSignGeneric(req);
        this.iframeUrl = response?.data?.data?.session?.client_url;
        this.step = 1;
      } catch (error) {
        this.iframeUrl = "";
        console.error("Error sending consent cellosign", error);
      } finally {
        this.isLoading = false;
      }
    },
    onStepBack() {
      this.step = 0;
      this.iframeUrl = "";
      this.selectedTemplate = "";
    }
  },
  async created() {
    const { appId, surgId } = this.$route.query;

    let patientData = null;

    if (appId) {
      const res = await this.$API.getAppointmentInfo(appId);
      patientData = res?.message?.appointment;
    } else if (surgId) {
      const res = await this.$API.getSurgeryInfo(surgId);
      patientData = res?.message?.patient;
    }

    if (!patientData) return;

    this.phone = patientData.phone;
    this.patient = {
      passport: patientData.passport || "",
      firstName: patientData.firstName || "",
      lastName: patientData.lastName || "",
      parentName: patientData.parent_name || ""
    };
  }
};
</script>

<style>
.cellosign-page .add_new_row_col2.w-100 {
  text-align: right;
}

.cellosign-page .add_new_row_col2 .multiselect__content-wrapper {
  direction: rtl;
  text-align: right;
}

.cellosign-page .add_new_row_col2 .multiselect__option {
  direction: rtl;
  text-align: right;
}

.cellosign-page .add_new_row_col2 .multiselect__placeholder,
.cellosign-page .add_new_row_col2 .multiselect__single {
  font-size: 26px;
  color: #2c2c2c;
}

.cellosign-page .form_submit {
  margin-top: 0;
}

.cellosign-page .form_input input,
.cellosign-page .form_input input:focus {
  height: 80px;
  min-height: 80px;
  flex-shrink: 0;
  padding-top: 0;
  box-sizing: border-box;
}

.cellosign-page .form_input {
  display: flex !important;
  flex-direction: column !important;
  height: auto !important;
  padding: 0 !important;
}

.cellosign-page .form_input label,
.cellosign-page .focused.form_input label {
  margin-bottom: 10px;
  position: static !important;
  top: auto !important;
  font-size: inherit;
  padding: 0;
  width: auto;
}

.cellosign-page .iframe-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.cellosign-page .back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #3498db;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 22px;
  font-weight: 500;
  width: fit-content;
  transition: background-color 0.2s ease;
}

.cellosign-page .back-button:hover {
  background-color: #2980b9;
}

.cellosign-page .back-button .arrow {
  font-size: 32px;
  line-height: 1;
  color: #ffffff;
}

.cellosign-page .back-button .text {
  text-decoration: none;
  color: #ffffff;
}

@media (max-width: 768px) {
  .cellosign-page .back-button {
    padding: 8px 10px;
    font-size: 18px;
    gap: 4px;
    border-radius: 6px;
  }

  .cellosign-page .back-button .arrow {
    font-size: 18px;
  }
}
</style>
